import {
    Component,
    EventEmitter,
    TemplateRef,
    Input,
    Output
} from '@angular/core';

@Component({
    selector: 'pm-bar-chart',
    //templateUrl: './app/controls/components/chart/bar-chart/bar-chart.html'
    templateUrl: './bar-chart.html',
})
export class BarChartComponent {

}


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/source/app/controls/components/chart/bar-chart/bar-chart-component.ts